import {
  AwaitedNotification,
  ColumnFilter,
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  DecimalScale,
  FilterType,
  FormDialogMode,
  FormSkeleton,
  SelectOption,
  useNotify,
  UserPermission
} from '@globaleris/ui.library'
import { Button, List, ListItem, makeStyles, Typography, useTheme } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { Cached, Delete, Edit, MoveToInbox } from '@material-ui/icons'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import ButtonWithPermissions from '../../../components/buttonWithPermissions/buttonWithPermissions'
import Page, { PageLayout } from '../../../components/page/page'
import PageCenterColumn from '../../../components/page/pageCenterColumn'
import PageHeader from '../../../components/page/pageHeader'
import PageLeftColumn from '../../../components/page/pageLeftColumn'

import {
  enumEnumToValueNumber,
  enumKeyToValue,
  enumToSelectOptionArray,
  enumValueToKey
} from '../../../helpers'
import { getUserPermissions, hasPermission } from '../../../helpers/permissionsHelper'

import {
  getCustomerDomain,
  notifyError,
  setIsLoading,
  storeActivePrice,
  storeDataTableFilterForCurrentPage,
  storeDataTableSearchForCurrentPage,
  storeVersions
} from '../../../redux/helpers'

import { EnumCommodity, EnumPrecioUnitario, EnumTipoPeaje } from '../../../api'
import { GlobalNotification, NonAuthRoutes } from '../../../model'
import { ConfirmationDialogs } from '../../../model/enums/confirmationDialogs'
import { Pages, Resources } from '../../../model/RBAC/constants'
import { PriceDetails, PriceValues, TabsPriceType } from '../pricing.Model'

import {
  FormDialogDefinitionProps,
  useConfirmationDialog,
  useErrorDetailListDialog,
  useFormDialog,
  useHttpError
} from '../../../hooks'

import {
  addValue,
  bulkDeletePricePeriodValues,
  checkValuesDates,
  deletePrice,
  deletePriceValue,
  fetchFranjasHorariasToList,
  fetchPriceDetails,
  fetchPricingEditValuesList,
  fetchSubscribedPricesById,
  recalculatePricesValues,
  updatePricePeriodValues,
  updateValue
} from '../pricing.service'

import { EnumMarketType } from '../../../api/Argentia/enums'
import { EnumRedondeo } from '../../../api/Argentia/enums/redondeo'
import { ErrorDetailList } from '../../../components/errorDetailList/errorDetailList'
import { mapFieldsToNewValuePost, mapPriceDetails, mapValuesFromAPI } from '../pricing.mapper'
import { styles } from './pricingEdit.styles'

import {
  PriceCoefficientAPI,
  PriceCoefficientTable
} from '../../../api/Argentia/endpoints/priceCoefficients/model/PriceCoefficient'
import { CreatePriceComponentRequest } from '../../../api/Argentia/endpoints/priceComponents'
import { PricePeriodValueGroupedModel } from '../../../api/Argentia/endpoints/pricing/model/values'
import { QuotePriceModelPatch } from '../../../api/Argentia/endpoints/quotes/model/quotes'
import { EnumHora, EnumQHora } from '../../../api/Argentia/enums/hora'
import { apiGetLeadByID } from '../../../api/Argentia/endpoints/leads/leads.api'
import { apiFetchContractByID } from '../../../api/Argentia/endpoints/contracts/contracts.api'
import { fetchFlexibilityByID } from '../../../api/Argentia/endpoints/flexibilities/flexibility.api'
import { EnumPriceComponentReference } from '../../../api/Argentia/enums/enumPriceComponentReference'
import { EnumPresionTension } from '../../../api/oData/enums/enumPresionTension'
import { apiGetQuote } from '../../../api/Argentia/endpoints/quotes/quotes.api'
import { EnumPriceType } from '../../../api/oData/enums/enumPriceType'
import { PriceCoefficientsCard } from '../../../components/shared/priceCoefficientsCard/priceCoefficientsCard'
import usePriceCoefficients from '../../../components/shared/priceCoefficientsTable/priceCoefficientsTable.hooks'
import { updatePriceCoefficients } from '../../../components/shared/priceCoefficientsTable/priceCoefficientsTable.service'
import { deletePriceComponent } from '../../../components/shared/priceComponentsTable/priceComponentsTable.service'
import { PricePeriodCard } from '../../../components/shared/pricePeriodCard/pricePeriodCard'
import { PricePeriodFormDialog } from '../../../components/shared/pricePeriodFormDialog/pricePeriodFormDialog'
import {
  mapPricePeriodFormDataToRequest,
  priceCoefficientAPIListtoTableMapper,
  priceCoefficientsToAPIMapper
} from '../../priceComponents/priceComponents.mapper'
import { getPriceComponentByPrice } from '../../priceComponents/priceComponents.service'
import { updateQuotePriceList } from '../../quotes/quotes.service'
import { AddMasiveDialog } from '../components/addMasiveDialog/addMasiveDialog'
import { EditPriceDialog } from '../components/editPriceDialog'
import { useGetPricePeriodByID } from '../priceComponentType/priceComponentTypeInstances/hooks/priceComponentType.instances.hooks'

export interface PricingTableProps {
  priceId: number
  location?: {
    state: {
      commodity: EnumCommodity
      priceType: EnumPriceType
      tabType: TabsPriceType
      priceComponentId?: number
      priceId?: number
      updateLgManual?: boolean
      quoteId?: number
    }
  }
}

export const PricingEditPage = props => {
  const history = useHistory()
  const [t] = useTranslation([
    'pricing',
    'pricingDetails',
    'globalerisLibrary',
    'enums',
    'priceComponent',
    'priceComponentTypeInstances'
  ])
  const { info, awaited, error } = useNotify()

  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const priceTypeIsNotDefined = props.location?.state?.priceType === undefined
  // if priceType is not defined, component deduce it after fetchin getPriceDetailsById(priceId)
  const [priceTypeIsParametroPeriodo, setPriceTypeIsParametroPeriodo] = useState<boolean>(
    props.location?.state?.priceType === EnumPriceType.ParametroPeriodo
  )
  const [priceTypeIsApuntamiento, setPriceTypeIsApuntamiento] = useState<boolean>(
    props.location?.state?.priceType === EnumPriceType.Apuntamiento
  )
  const [showPricePeriod, setShowPricePeriod] = useState<boolean>(priceTypeIsParametroPeriodo)
  const [showPriceCoefficients, setShowPriceCoefficients] =
    useState<boolean>(priceTypeIsApuntamiento)
  const parametroPeriodoPriceID = props.location?.state?.priceId
  const apuntamientoPriceID = priceTypeIsApuntamiento ? props.location?.state?.priceId : undefined

  const {
    isFetching: isFetchingPricePeriods,
    fetchData: pricePeriodData,
    getPricePeriodByID: refreshPricePeriod
  } = useGetPricePeriodByID(
    (errorMsg: string) => error(t(errorMsg)),
    parametroPeriodoPriceID ?? 0,
    showPricePeriod
  )

  const {
    priceCoefficients,
    isFetchingPriceCoefficients,
    errorFetchPriceCoefficients,
    refreshPriceCoefficients
  } = usePriceCoefficients({ priceID: apuntamientoPriceID }, showPriceCoefficients)
  const [priceCoefficientData, setPriceCoefficientData] = useState<PriceCoefficientTable[]>([])
  const [isSavingPriceCoefficientsDisabled, setIsSavingPriceCoefficientsDisabled] =
    useState<boolean>(true)

  const [pricePeriodFormDialogOpen, setPricePeriodFormDialogOpen] = useState<boolean>(false)
  const [pricePeriodFormMode, setPricePeriodFormMode] = useState<FormDialogMode>(FormDialogMode.ADD)
  const [pricePeriodFormInputData, setPricePeriodFormInputData] = useState<
    PricePeriodValueGroupedModel | undefined
  >()

  const [priceDetails, setPriceDetails] = useState<PriceDetails | undefined>(undefined)
  const [priceValues, setPriceValues] = useState<PriceValues[] | undefined>(undefined)
  const [newPriceValue, setNewPriceValue] = useState<PriceValues | undefined>(undefined)
  const [priceComponentID, setPriceComponentID] = useState<number | undefined>(undefined)
  const [linkedPriceComponentTypeCode, setLinkedPriceComponentTypeCode] = useState<
    string | undefined
  >(undefined)
  const [linkedEntityCode, setLinkedEntityCode] = useState<string | undefined>(undefined)
  const [isFetchingLinkedComponent, setIsFetchingLinkedComponent] = useState<boolean>(
    props.location?.state?.priceType === EnumPriceType.Apuntamiento ||
      props.location?.state?.priceType === EnumPriceType.Parametro
  )

  const [timeFrames, setTimeFrames] = useState<SelectOption[]>([])
  const [hasSubscribed, setHasSubscribed] = useState<boolean>(true)
  const [isFetching, setIsFetching] = useState<boolean>(true)
  const [globalNotification, setGlobalNotification] = useState<GlobalNotification | undefined>(
    undefined
  )
  const [showEditPriceDialog, setShowEditPriceDialog] = useState<boolean>(false)
  const [openAddMassiveDialog, setOpenAddMassiveDialog] = useState<boolean>(false)
  const [hoursOptions, setHourOptions] = useState<SelectOption[]>([])
  const [qhOptions, setQhOptions] = useState<SelectOption[]>([])

  const { showError, clearError, errorProps } = useHttpError()

  const { showErrorDetailListDialog, errorDetailListDialogProps } = useErrorDetailListDialog()

  const priceDeleteDisabled =
    (!!props.location.state.priceId && hasSubscribed) ||
    props.location.state.tabType === TabsPriceType.baseComponents

  const priceId = props.location?.state?.priceId
  const updateLgManual = props.location?.state?.updateLgManual
  const quoteId = props.location?.state?.quoteId
  const propsPriceComponentId = props.location?.state?.priceComponentId

  interface formDependenciesProps {
    formState: any
  }

  const [addValueFormDependencies, setAddValueFormDependencies] = useState<formDependenciesProps>({
    formState: {}
  })

  const [editValueFormDependencies, setEditValueFormDependencies] = useState<formDependenciesProps>(
    {
      formState: {}
    }
  )
  const { openForm, updateFormDefinition, closeForm, formProps, CustomFormDialog, setFormWaiting } =
    useFormDialog()
  const { getConfirmation, closeConfirmation } = useConfirmationDialog()

  const sortHoursLabels = (valuesArray: SelectOption[] = []) => {
    const sortedArray = valuesArray.sort((a, b) => {
      return String(a.value).localeCompare(String(b.value), 'es', { sensitivity: 'base' })
    })
    return sortedArray
  }

  const cmp = function (a, b) {
    if (a > b) return +1
    if (a < b) return -1
    return 0
  }

  // SelectOption to be used at forms and dataTables. Includes daylight savings hours like "Hora3V" which is showed as "03:00 (Verano)".
  // Sorted in a way so same hours for different seasons are shown together, like 03:00, 03:00 Verano and 03:00 Invierno.
  // Needs to be in the component, otherwise it doesn't have access to the translation hook.
  const tableHoursFormat = sortHoursLabels(
    enumToSelectOptionArray(EnumHora, 'pricingDetails:EnumHora').map(option => {
      return { ...option, value: EnumHora[option.value] }
    })
  ).sort((a, b) => {
    return cmp(a.label.charAt(0), b.label.charAt(0)) || cmp(a.label.charAt(1), b.label.charAt(1))
  })

  const tableQHoursFormat = sortHoursLabels(
    enumToSelectOptionArray(EnumQHora, 'pricingDetails:EnumQHora')
  ).sort((a, b) => {
    return cmp(a.label.charAt(0), b.label.charAt(0)) || cmp(a.label.charAt(1), b.label.charAt(1))
  })

  const getErrorMsg = (error): string => {
    if (error.code === 5003) {
      return t('pricingDetails:notifications.datesGapValidation.error')
    } else if (error.code === 5004) {
      return t('pricingDetails:notifications.datesOverlapValidation.error')
    } else return error.description ?? ''
  }

  // Handlers Starts

  const getInitialHourOptions = () => {
    const lastDay = getFirstImmediateDay()
    checkIsDaylightSavingDay(lastDay)
  }

  const onAddValueClickHandler = () => {
    openForm({
      definition: addValueFormDefinition,
      title: t('pricingDetails:forms.addValue.title'),
      mode: FormDialogMode.ADD,
      isWaiting: false,
      onClose: onAddValueHandler
    })

    setAddValueFormDependencies({
      ...addValueFormDependencies,
      formState: newPriceValue
    })
  }

  const onAddValueHandler = async (value: PriceValues) => {
    if (value) {
      // Gap and Overlap dates validation for all Parameter prices, null/monthly/trimestral Cotizations prices and null/monthly/trimestral Futures prices.
      const isParameter = props.location.state.priceType === EnumPriceType.Parametro
      const isCotizationOrFuture =
        (priceDetails?.marketType === EnumMarketType.Mensual ||
          priceDetails?.marketType === EnumMarketType.Trimestral ||
          priceDetails?.marketType == null) &&
        (props.location.state.priceType === EnumPriceType.Cotizacion ||
          props.location.state.priceType === EnumPriceType.Futuro)
      if (isParameter || isCotizationOrFuture) {
        // const datesAreValid = validateParameterDates(value, value.startDate, value.endDate);
        const response =
          priceDetails &&
          (await checkValuesDates(
            {
              ...value,
              endDate: isParameter && value.endDate == null ? value.startDate : value.endDate
            },
            priceDetails?.id
          ))
        if (response && response.success) {
          if (!response.data.isValid) {
            response.data.status.errors.map(error => notifyError(getErrorMsg(error)))
            return
          }
        } else {
          notifyError(
            'Error interno al intentar validar Fecha de Inicio y Fin. Inténtelo nuevamente.'
          )
          return
        }
      }

      const valueToMap = mapFieldsToNewValuePost(
        props.location.state.priceType,
        priceDetails?.marketType,
        value
      )
      setFormWaiting(true)
      addValue(priceDetails?.id, valueToMap, priceComponentID).then(async response => {
        if (response.success) {
          fetchPriceValuesList(props.location.state.priceId)
          info(t('pricingDetails:notifications.createValue.success'))
        } else {
          response.error
            ? showErrorDetailListDialog(
                t('pricingDetails:notifications.createValue.error'),
                [response.error],
                moment().format('DD/MM/YYYY')
              )
            : notifyError(t('httpErrors:api.subtitle'))
        }
        closeForm()
      })
    } else {
      closeForm()
    }
  }

  const onEditValueClickHandler = async (value: PriceValues) => {
    openForm({
      definition: editValueFormDefinition,
      title: t('pricingDetails:forms.editValue.title'),
      mode: FormDialogMode.EDIT,
      isWaiting: false,
      onClose: onEditValueHandler
    })

    setEditValueFormDependencies({
      ...editValueFormDependencies,
      formState: value
    })
  }

  const onEditValueHandler = async (value: PriceValues) => {
    if (value) {
      const isParameter = props.location.state.priceType === EnumPriceType.Parametro
      const isCotizationOrFuture =
        (priceDetails?.marketType === EnumMarketType.Mensual ||
          priceDetails?.marketType === EnumMarketType.Trimestral ||
          priceDetails?.marketType == null) &&
        (props.location.state.priceType === EnumPriceType.Cotizacion ||
          props.location.state.priceType === EnumPriceType.Futuro)
      if (isParameter || isCotizationOrFuture) {
        // const datesAreValid = validateParameterDates(value, value.startDate, value.endDate);
        const response =
          priceDetails &&
          (await checkValuesDates(
            {
              ...value,
              endDate: isParameter && value.endDate == null ? value.startDate : value.endDate
            },
            priceDetails?.id
          ))
        if (response && response.success) {
          if (!response.data.isValid) {
            response.data.status.errors.map(error => notifyError(getErrorMsg(error)))
            return
          }
        } else {
          notifyError(
            'Error interno al intentar validar Fecha de Inicio y Fin. Inténtelo nuevamente.'
          )
          return
        }
      }

      const valueToMap = mapFieldsToNewValuePost(
        priceDetails?.priceType,
        priceDetails?.marketType,
        value
      )

      setFormWaiting(true)
      if (isParameter || isCotizationOrFuture) {
        deletePriceValue(props.location.state.priceId, value.id, priceComponentID).then(
          async response => {
            if (response.success) {
              updateValue(priceDetails?.id, valueToMap, priceComponentID).then(async response => {
                if (response.success) {
                  fetchPriceValuesList(props.location.state.priceId)
                  info(t('pricingDetails:notifications.updateValue.success'))
                }
              })

              if (updateLgManual) {
                updateQuotePriceList(quoteId, priceComponentID ?? propsPriceComponentId, {
                  quoteId: quoteId,
                  lgManual: true
                } as QuotePriceModelPatch).then(res => {
                  res.success
                    ? info(t('pricingDetails:notifications.updateQuotePriceList.success'))
                    : error(t('pricingDetails:notifications.updateQuotePriceList.error'))
                })
              }
            } else {
              notifyError(t('pricingDetails:notifications.updateValue.error'))
            }
            closeForm()
          }
        )
      } else {
        updateValue(priceDetails?.id, valueToMap).then(async response => {
          if (response.success) {
            fetchPriceValuesList(props.location.state.priceId)
            info(t('pricingDetails:notifications.updateValue.success'))

            if (updateLgManual) {
              updateQuotePriceList(quoteId, priceComponentID ?? propsPriceComponentId, {
                quoteId: quoteId,
                lgManual: true
              } as QuotePriceModelPatch).then(res => {
                res.success
                  ? info(t('pricingDetails:notifications.updateQuotePriceList.success'))
                  : error(t('pricingDetails:notifications.updateQuotePriceList.error'))
              })
            }
          } else {
            notifyError(t('pricingDetails:notifications.updateValue.error'))
          }
        })
        closeForm()
      }
    } else {
      // Click on Cancel button.
      closeForm()
    }
  }

  const onDeleteValueClickHandler = (value: PriceValues) => {
    getConfirmation(ConfirmationDialogs.DELETE_PRICEVALUE).then(async () => {
      deletePriceValue(props.location.state.priceId, value.id, priceComponentID).then(
        async response => {
          if (response.success) {
            fetchPriceValuesList(props.location.state.priceId)
            info(t('pricingDetails:notifications.deleteValue.success'))
          } else {
            response.error
              ? showErrorDetailListDialog(
                  t('pricingDetails:notifications.deleteValue.error'),
                  [response.error],
                  moment().format('DD/MM/YYYY')
                )
              : notifyError(t('httpErrors:api.subtitle'))
          }
        }
      )
      closeConfirmation()
    })
  }

  const onDeleteClickHandler = () => {
    getConfirmation(ConfirmationDialogs.DELETE_PRICE).then(async () => {
      // We check the id received from getPriceById api is the same of priceId we selected or created on the previous page. This MUST be always true.
      if (props.location.state.priceId === priceDetails?.id) {
        deletePrice(props.location.state.priceId).then(async response => {
          if (response.success) {
            history.push(NonAuthRoutes.pricing)
            info(
              t('pricingDetails:notifications.deletePrice.success', {
                priceCode: priceDetails?.code
              })
            )
          } else {
            response.error
              ? showErrorDetailListDialog(
                  t('pricingDetails:notifications.deletePrice.error', {
                    priceCode: priceDetails?.code
                  }),
                  [response.error],
                  moment().format('DD/MM/YYYY')
                )
              : notifyError(t('httpErrors:api.subtitle'))
          }
        })
      }
      closeConfirmation()
    })
  }

  const onDeleteComponentClickHandler = () => {
    getConfirmation(ConfirmationDialogs.DELETE_PRICECOMPONENT).then(async () => {
      if (priceComponentID) {
        await deletePriceComponent(priceComponentID).then(response => {
          if (response.success) {
            history.push(NonAuthRoutes.pricing)
            info(t('pricingDetails:notifications.deletePriceComponent.success'))
          } else {
            response.error
              ? showErrorDetailListDialog(
                  t('pricingDetails:notifications.deletePriceComponent.error', {
                    priceCode: priceDetails?.code
                  }),
                  [response.error],
                  moment().format('DD/MM/YYYY')
                )
              : notifyError(t('httpErrors:api.subtitle'))
          }
        })
      }
      closeConfirmation()
    })
  }

  const onEditComponentClickHandler = () => {
    priceComponentID &&
      history.push(NonAuthRoutes.PriceComponentsAdd, {
        id: priceComponentID
      })
  }

  // Temporary until API's finished.
  const handleRecalculateValues = async () => {
    getConfirmation(ConfirmationDialogs.RECALCULATE_CALCULATEDINDEX).then(async () => {
      closeConfirmation()

      awaited({
        title: t('pricingDetails:notifications.recalculatePrices.title', {
          priceCode: priceDetails?.code
        }),
        message: t('pricingDetails:notifications.recalculatePrices.message'),
        keyInfo: priceDetails!.id.toString()
      } as AwaitedNotification)

      recalculatePricesValues(priceDetails!.id)
    })
    setIsLoading(false)
  }

  /*   const [startRetriesTimer, stopRetriesTimer] = useRetries(
    async () => {
      await fetchPriceValuesList(props.location.state.priceId)
    },
    5000,
    {
      immediate: true,
      onRetry: count => {
        setGlobalNotification({
          icon: NotificationMessageIcons.LOADING,
          message: t('pricingDetails:globalNotifications.retries.messages.onRetry', {
            count: count
          }),
          actions: [
            {
              label: t('pricingDetails:globalNotifications.retries.actions.cancel'),
              onClick: () => {
                stopRetriesTimer()
                setGlobalNotification({
                  message: t('pricingDetails:globalNotifications.retries.messages.onStop'),
                  actions: [
                    {
                      label: t('pricingDetails:globalNotifications.retries.actions.refresh'),
                      onClick: async () => {
                        await fetchPriceValuesList(props.location.state.priceId)
                      }
                    },
                    {
                      label: t('pricingDetails:globalNotifications.retries.actions.close'),
                      onClick: () => {
                        setGlobalNotification(undefined)
                      }
                    }
                  ]
                })
              }
            }
          ]
        })
      },
      onFinishRetries: () => {
        setGlobalNotification({
          icon: NotificationMessageIcons.INFO,
          message: t('pricingDetails:globalNotifications.retries.messages.onFinish'),
          actions: [
            {
              label: t('pricingDetails:globalNotifications.retries.actions.refresh'),
              onClick: async () => {
                await fetchPriceValuesList(props.location.state.priceId)
              }
            },
            {
              label: t('pricingDetails:globalNotifications.retries.actions.close'),
              onClick: () => {
                setGlobalNotification(undefined)
              }
            }
          ]
        })
      },
      onError: error => {
        setGlobalNotification({
          icon: NotificationMessageIcons.ERROR,
          message: t('pricingDetails:globalNotifications.retries.messages.onError'),
          actions: [
            {
              label: t('pricingDetails:globalNotifications.retries.actions.refresh'),
              onClick: async () => {
                await fetchPriceValuesList(props.location.state.priceId)
              }
            }
          ]
        })
      }
    }
  ) */

  const handleCloseAddMasive = () => {
    setOpenAddMassiveDialog(false)
  }

  // ------------------- pricePeriod DataTable Action Handlers -----------------------------//

  const handleAddPricePeriod = () => {
    // Add Price Period Logic
    setPricePeriodFormMode(FormDialogMode.ADD)
    setPricePeriodFormDialogOpen(true)
  }

  const handleEditPricePeriod = (selectedRow: PricePeriodValueGroupedModel) => {
    // Edit Price Period Logic
    setPricePeriodFormMode(FormDialogMode.EDIT)
    setPricePeriodFormDialogOpen(true)
    setPricePeriodFormInputData(selectedRow)
  }

  const handleDeletePricePeriod = async (selectedRow: PricePeriodValueGroupedModel) => {
    getConfirmation(ConfirmationDialogs.DELETE_PERIOD_PRICEVALUE).then(async () => {
      const priceValuesIds: number[] = Object.keys(selectedRow)
        .map(key => selectedRow[key]?.id)
        .filter(item => item !== undefined && item !== null)
      parametroPeriodoPriceID &&
        (await bulkDeletePricePeriodValues(parametroPeriodoPriceID, priceValuesIds).then(
          response => {
            if (response.success) {
              info(t('priceComponent:forms.pricePeriodValueForm.notifications.delete.success'))
              refreshPricePeriod(parametroPeriodoPriceID ?? 0)
            } else {
              error(t('priceComponent:forms.pricePeriodValueForm.notifications.delete.error'))
            }
          }
        ))
      closeConfirmation()
    })
  }

  // ------------------- pricePeriod Form Dialog Handlers -----------------------------//
  const handlePricePeriodFormDialogClose = async (formData: PricePeriodValueGroupedModel) => {
    if (formData) {
      const request = mapPricePeriodFormDataToRequest(formData)
      await updatePricePeriodValues(parametroPeriodoPriceID!, request).then(response => {
        if (response.success) {
          info(t('priceComponent:forms.pricePeriodValueForm.notifications.edit.success'))
          refreshPricePeriod(parametroPeriodoPriceID ?? 0)
        } else {
          error(t('priceComponent:forms.pricePeriodValueForm.notifications.edit.error'))
        }
      })
    }
    setPricePeriodFormDialogOpen(false)
  }

  // ------------------- priceCoefficients Card Dialog Handlers -----------------------------//
  const handlePriceCoefficientsDataChange = (data: PriceCoefficientTable[]) => {
    setIsSavingPriceCoefficientsDisabled(false)
    setPriceCoefficientData([...data])
    if (data.length === 0) {
      handleSavePriceCoefficients(data)
    }
  }

  const handleSavePriceCoefficients = (data: PriceCoefficientTable[]) => {
    const priceCoefficients = priceCoefficientsToAPIMapper(data)
    priceDetails?.id && updatePriceCoefficientsAsync(priceDetails.id, priceCoefficients)
  }

  const updatePriceCoefficientsAsync = async (
    priceId: number,
    priceCoefficients: (PriceCoefficientAPI | CreatePriceComponentRequest['priceCoefficients'])[]
  ) => {
    await updatePriceCoefficients({ idPrice: priceId, priceCoefficients }).then(response => {
      if (response.success) {
        info(t('priceComponent:forms.editValues.notifications.success'))
        refreshPriceCoefficients()
      } else {
        showErrorDetailListDialog(
          t('priceComponent:notifications.rulebook'),
          response.error
            ? [{ code: response.error.code, message: `${response.error.message}` }]
            : [{ code: '412', message: '9001' }],
          t('priceComponent:notifications.update.error')
        )
      }
    })
  }

  // -------------------- Header Back Button Handler ------------------------------//

  const onBackButtonClickHandler = async () => {
    storeActivePrice(null)
    storeVersions(null)

    if (!isSavingPriceCoefficientsDisabled) {
      await getConfirmation(ConfirmationDialogs.CANCEL_PENDING_CHANGES).then(async () => {
        history.goBack()
        closeConfirmation()
      })
    } else {
      history.goBack()
    }
  }
  // Handlers Ends

  // Functions Starts

  const sortByDateAndTime = (valuesArray: PriceValues[] | undefined = []) => {
    const sortedArray = valuesArray.sort((a, b) => {
      const x = new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
      if (x) return x

      // Si los datos tienen qHora, es mercado cuarto horario
      if (a.qHora != null || b.qHora != null) {
        return (b.qHora ?? 0) - (a.qHora ?? 0)
      }

      return b.hora - a.hora
    })

    return sortedArray
  }

  const fetchPriceDetailsById = async (id: number) => {
    setIsFetching(true)

    await fetchPriceDetails(id).then(response => {
      setIsFetching(false)
      if (response.success) {
        clearError()
        setPriceDetails(mapPriceDetails(response.data))
        storeActivePrice({
          ...mapPriceDetails(response.data),
          commodity: props.location.state.commodity,
          priceType: props.location.state.priceType
        })
        if (response.data && priceTypeIsNotDefined) {
          if (
            response.data.priceType ===
            enumValueToKey(EnumPriceType, EnumPriceType.ParametroPeriodo)
          ) {
            setPriceTypeIsParametroPeriodo(true)
            setShowPricePeriod(true)
          } else if (
            response.data.priceType === enumValueToKey(EnumPriceType, EnumPriceType.Apuntamiento)
          ) {
            setPriceTypeIsApuntamiento(true)
            setShowPriceCoefficients(true)
          }
        }
      } else {
        response.error &&
          showError({
            title: t('pricingDetails:title'),
            errorCode: response.error.code,
            onRefresh: async () => {
              fetchPriceDetails(id)
            }
          })
      }
    })

    if (
      props.location.state.priceType === EnumPriceType.Apuntamiento ||
      props.location.state.priceType === EnumPriceType.Parametro
    ) {
      fetchPriceComponentForPrice(props.location.state.priceId)
    }
  }

  const fetchPriceValuesList = async (id: number) => {
    setIsFetching(true)

    await fetchPricingEditValuesList(id).then(response => {
      setIsFetching(false)
      if (response.success) {
        clearError()
        const sortedData = sortByDateAndTime(response.data)
        console.log('sortedData', sortedData)
        const mapped = mapValuesFromAPI(sortedData, props.location.state.priceType)
        setPriceValues(mapped)
      } else {
        response.error &&
          notifyError(
            t('pricingDetails:notifications.loadPriceValues.error', {
              error: response.error.code
            })
          )
      }
    })
  }

  const fetchPriceComponentForPrice = async (priceID: number) => {
    try {
      await getPriceComponentByPrice(priceID).then(async response => {
        if (response.success && response.data) {
          clearError()
          const pc = response.data as typeof response.data & {
            presionTension?: number
            idOferta?: number
          }
          setPriceComponentID(pc.id)
          setLinkedPriceComponentTypeCode(pc.typeCode)

          const reference = enumEnumToValueNumber(EnumPriceComponentReference, pc.priceReference)
          try {
            if (reference === EnumPriceComponentReference.Lead && pc.idLead) {
              const lead = await apiGetLeadByID(pc.idLead)
              setLinkedEntityCode(lead?.code)
            } else if (reference === EnumPriceComponentReference.Contrato && pc.idContract) {
              const contract = await apiFetchContractByID(pc.idContract)
              setLinkedEntityCode(contract?.contractCode)
            } else if (reference === EnumPriceComponentReference.Flexibilidad && pc.idFlexibility) {
              const flex = await fetchFlexibilityByID(pc.idFlexibility)
              setLinkedEntityCode(flex?.description) //NOTA: En el caso de las flexibilidades como no tenemos codigo utilizamos la descripcion.
            } else if (reference === EnumPriceComponentReference.Peaje && pc.toll != null) {
              const tollKey = Object.keys(EnumTipoPeaje).find(
                k => EnumTipoPeaje[k as keyof typeof EnumTipoPeaje] === pc.toll
              )
              setLinkedEntityCode(tollKey)
            } else if (
              reference === EnumPriceComponentReference.PresionTension &&
              pc.presionTension != null
            ) {
              const presionKey = enumValueToKey(EnumPresionTension, pc.presionTension)
              setLinkedEntityCode(presionKey)
            } else if (reference === EnumPriceComponentReference.Oferta && pc.idOferta) {
              const quote = await apiGetQuote(pc.idOferta)
              setLinkedEntityCode(quote?.code)
            } else if (
              reference === EnumPriceComponentReference.RegionImpuestos &&
              pc.regionImpuestos
            ) {
              setLinkedEntityCode(pc.regionImpuestos)
            }
          } catch {}
        }
      })
    } finally {
      setIsFetchingLinkedComponent(false)
    }
  }

  const fetchSubscribedPrices = async () => {
    await fetchSubscribedPricesById(props.location.state.priceId).then(response => {
      if (response.success) {
        if (response.data !== null && response.data.length > 0) {
          setHasSubscribed(true)
        } else {
          setHasSubscribed(false)
        }
      } else {
        setHasSubscribed(true)
      }
    })
  }

  const fetchFranjasHorarias = async () => {
    const timeFramesList = await fetchFranjasHorariasToList()
    timeFramesList && setTimeFrames(timeFramesList)
  }

  const getFirstImmediateDay = () => {
    if (priceValues && priceValues?.length > 0) {
      const lastDay = priceValues[0].endDate || priceValues[0].startDate
      return moment(lastDay).add(1, 'day').toDate()
    }
    return new Date()
  }

  const getNextMonthFirstDay = () => {
    if (priceValues && priceValues?.length > 0) {
      const lastDay = priceValues[0].endDate || priceValues[0].startDate
      const a = moment(lastDay).add(1, 'month').startOf('month').toDate()
      return moment(lastDay).add(1, 'month').startOf('month').toDate()
    }
    return new Date()
  }

  const getNextMonthLastDay = () => {
    if (priceValues && priceValues?.length > 0) {
      const lastDay = priceValues[0].endDate || priceValues[0].startDate
      const a = moment(lastDay).add(1, 'month').endOf('month').toDate()
      return moment(lastDay).add(1, 'month').endOf('month').toDate()
    }
    return new Date()
  }

  const getCurrentMonthFirstDay = () => {
    const currentDay = new Date()
    return moment(currentDay).startOf('month').toDate()
  }

  const getCurrentMonthLastDay = () => {
    const currentDay = new Date()
    return moment(currentDay).endOf('month').toDate()
  }

  const getCurrentTrimesterFirstDay = () => {
    const currentDay = new Date()
    return moment(currentDay).startOf('month').toDate()
  }

  const getCurrentTrimesterLastDay = () => {
    const currentDay = new Date()
    return moment(currentDay).add(3, 'month').endOf('month').toDate()
  }

  const getNextTrimesterFirstDay = () => {
    if (priceValues && priceValues?.length > 0) {
      const lastDay = priceValues[0].endDate || priceValues[0].startDate
      const a = moment(lastDay).add(1, 'month').startOf('month').toDate()
      return moment(lastDay).add(1, 'month').startOf('month').toDate()
      // return moment(lastDay).add(1, 'day').toDate();
    }
    return new Date()
  }

  const getNextTrimesterLastDay = () => {
    if (priceValues && priceValues?.length > 0) {
      const lastDay = priceValues[0].endDate || priceValues[0].startDate
      const a = moment(lastDay).add(3, 'month').endOf('month').toDate()
      return moment(lastDay).add(3, 'month').endOf('month').toDate()
      // return moment(lastDay).add(1, 'day').toDate();
    }
    return new Date()
  }

  const lastSunday = (year, month) => {
    const date = new Date(year, month, 1, 12)
    return date.toDateString()
  }

  const checkIsDaylightSavingDay = (date: any): void => {
    const dateYear = moment(date).year()
    const winterSunday = lastSunday(dateYear, 10)
    const summerSunday = lastSunday(dateYear, 3)
    if (moment(date).isSame(winterSunday)) {
      defineHourOptions('winter')
    } else if (moment(date).isSame(summerSunday)) {
      defineHourOptions('summer')
    } else {
      defineHourOptions('regular')
    }
  }

  const defineHourOptions = (hours: string) => {
    if (hours === 'regular') {
      // for regular days, hide 03:00 daylight savings options, only show standard 03:00.
      const regularHourOptions = tableHoursFormat.filter(
        hour => hour.value !== 'Hora3I' && hour.value !== 'Hora3V'
      )
      setHourOptions(regularHourOptions)

      const excludeQH = [251, 252, 253, 254, 261, 262, 263, 264]
      const regularQhOptions = tableQHoursFormat.filter(
        hour => !excludeQH.includes(hour.value as number)
      )
      setQhOptions(regularQhOptions)
    } else if (hours === 'winter') {
      // for last sunday of october, show 03:00 Summer and 03:00 Winter options, hide standard 03:00.
      const winterHourOptions = tableHoursFormat.filter(hour => hour.value !== 'Hora3')
      setHourOptions(winterHourOptions)

      const excludeQH = [31, 32, 33, 34]
      const winterQhOptions = tableQHoursFormat.filter(
        hour => !excludeQH.includes(hour.value as number)
      )
      setQhOptions(winterQhOptions)
    } else if (hours === 'summer') {
      // for last sunday of march, hide all 03:00 options.
      const summerHourOptions = tableHoursFormat.filter(
        hour => hour.value !== 'Hora3I' && hour.value !== 'Hora3V' && hour.value !== 'Hora3'
      )
      setHourOptions(summerHourOptions)

      const excludeQH = [31, 32, 33, 34, 251, 252, 253, 254, 261, 262, 263, 264]
      const summerQhOptions = tableQHoursFormat.filter(
        hour => !excludeQH.includes(hour.value as number)
      )
      setQhOptions(summerQhOptions)
    }
  }

  const getDefaultStartDates = (
    currentPriceType: EnumPriceType,
    currentMarketType: EnumMarketType | null | undefined
  ): Date => {
    if (
      currentPriceType === EnumPriceType.Cotizacion ||
      currentPriceType === EnumPriceType.Futuro
    ) {
      switch (currentMarketType) {
        case EnumMarketType.Diario:
          return getFirstImmediateDay()
          break
        case EnumMarketType.Laborables:
          return getFirstImmediateDay()
          break
        case EnumMarketType.Mensual: {
          if (priceValues && priceValues.length > 0) {
            return getNextMonthFirstDay()
            break
          } else {
            return getCurrentMonthFirstDay()
            break
          }
        }
        case EnumMarketType.Trimestral: {
          if (priceValues && priceValues.length > 0) {
            return getNextTrimesterFirstDay()
            break
          } else {
            return getCurrentMonthFirstDay()
            break
          }
        }
        default:
          return new Date()
      }
    } else if (currentPriceType === EnumPriceType.Parametro) {
      // Parameter Prices: Default dates are last endDate + 1 or current system Date.
      getFirstImmediateDay()
    }
    return new Date()
  }

  const getDefaultEndDates = (
    currentPriceType: EnumPriceType,
    currentMarketType: EnumMarketType | null | undefined
  ): Date => {
    if (
      currentPriceType === EnumPriceType.Cotizacion ||
      currentPriceType === EnumPriceType.Futuro
    ) {
      switch (currentMarketType) {
        case EnumMarketType.Diario:
          return getFirstImmediateDay()
          break
        case EnumMarketType.Laborables:
          return getFirstImmediateDay()
          break
        case EnumMarketType.Mensual: {
          if (priceValues && priceValues.length > 0) {
            return getNextMonthLastDay()
          } else {
            return getCurrentMonthLastDay()
          }
          break
        }
        case EnumMarketType.Trimestral: {
          if (priceValues && priceValues.length > 0) {
            return getNextTrimesterLastDay()
            break
          } else {
            return getCurrentTrimesterLastDay()
            break
          }
        }
        default:
          return new Date()
      }
    } else if (currentPriceType === EnumPriceType.Parametro) {
      // Parameter Prices: Default dates are last endDate + 1 or current system Date.
      getFirstImmediateDay()
    }
    return new Date()
  }

  // Functions Ends

  // Form Definition Starts

  const addValueFormDefinition =
    React.useMemo<FormDialogDefinitionProps>((): FormDialogDefinitionProps => {
      return {
        id: 'ADD_VALUE',
        sections: [
          {
            inputs: [
              {
                name: 'startDate',
                label:
                  priceDetails?.marketType === EnumMarketType.Diario ||
                  priceDetails?.marketType === EnumMarketType.Horario ||
                  priceDetails?.marketType === EnumMarketType.CuartoHorario ||
                  priceDetails?.marketType === EnumMarketType.Laborables
                    ? t('pricingDetails:forms.addValue.inputs.date')
                    : t('pricingDetails:forms.addValue.inputs.startDate'),
                type: DataType.DATE,
                required: true,
                defaultValue: getDefaultStartDates(
                  props.location.state.priceType,
                  priceDetails?.marketType
                ),
                // props.location.state.priceType === PriceTypes.cotization ||
                // props.location.state.priceType === PriceTypes.parameter
                //   ? getLastAvailableDay()
                //   : new Date(),
                onChange: (value, formState: any) => {
                  if (!moment(value).isValid()) {
                    return
                  }
                  if (formState.endDate && moment(formState.endDate).isBefore(moment(value))) {
                    setAddValueFormDependencies({
                      ...addValueFormDependencies,
                      formState: {
                        ...formState,
                        manual: true,
                        startDate: moment(value).toDate(),
                        endDate: moment(formState.startDate).toDate()
                      }
                    })
                    if (
                      priceDetails?.marketType === EnumMarketType.Diario ||
                      priceDetails?.marketType === EnumMarketType.Horario ||
                      priceDetails?.marketType === EnumMarketType.CuartoHorario ||
                      priceDetails?.marketType === EnumMarketType.Laborables
                    ) {
                      setAddValueFormDependencies({
                        ...addValueFormDependencies,
                        formState: {
                          ...formState,
                          endDate: moment(value).toDate()
                        }
                      })
                      setFormWaiting(true)
                      checkIsDaylightSavingDay(value)
                      setFormWaiting(false)
                    }
                  } else {
                    setAddValueFormDependencies({
                      ...addValueFormDependencies,
                      formState: {
                        ...formState,
                        startDate: moment(value).toDate(),
                        endDate: formState.endDate ? moment(formState.endDate).toDate() : undefined
                      }
                    })
                    if (
                      priceDetails?.marketType === EnumMarketType.Diario ||
                      priceDetails?.marketType === EnumMarketType.Horario ||
                      priceDetails?.marketType === EnumMarketType.CuartoHorario ||
                      priceDetails?.marketType === EnumMarketType.Laborables
                    ) {
                      setAddValueFormDependencies({
                        ...addValueFormDependencies,
                        formState: {
                          ...formState,
                          endDate: moment(value).toDate()
                        }
                      })
                      setFormWaiting(true)
                      checkIsDaylightSavingDay(value)
                      setFormWaiting(false)
                    }
                  }
                }
              },
              {
                name: 'endDate',
                label: t('pricingDetails:forms.addValue.inputs.endDate'),
                type: DataType.DATE,
                defaultValue: getDefaultEndDates(
                  props.location.state.priceType,
                  priceDetails?.marketType
                ),
                required:
                  priceDetails?.marketType === EnumMarketType.Diario ||
                  priceDetails?.marketType === EnumMarketType.Horario ||
                  priceDetails?.marketType === EnumMarketType.Laborables ||
                  props.location.state.priceType === EnumPriceType.Parametro
                    ? undefined
                    : true,
                clearable:
                  props.location.state.priceType === EnumPriceType.Parametro ? true : undefined,
                display:
                  priceDetails?.marketType !== EnumMarketType.Diario &&
                  priceDetails?.marketType !== EnumMarketType.Horario &&
                  priceDetails?.marketType !== EnumMarketType.CuartoHorario &&
                  priceDetails?.marketType !== EnumMarketType.Laborables,
                onChange: (value, formState: any) => {
                  if (!moment(value).isValid()) {
                    return
                  }
                  if (formState.startDate && moment(value).isBefore(moment(formState.startDate))) {
                    setAddValueFormDependencies({
                      ...addValueFormDependencies,
                      formState: { ...formState, endDate: moment(formState.startDate).toDate() }
                    })
                  } else {
                    setAddValueFormDependencies({
                      ...addValueFormDependencies,
                      formState: {
                        ...formState,
                        endDate: moment(value).toDate(),
                        startDate:
                          formState.startDate !== undefined
                            ? moment(formState.startDate).toDate()
                            : undefined
                      }
                    })
                  }
                }
              },
              {
                name: 'hora',
                label: t('pricingDetails:forms.addValue.inputs.hour'),
                type: DataType.SELECT,
                selectOptions: hoursOptions,
                required: priceDetails?.marketType === EnumMarketType.Horario,
                clearable:
                  props.location.state.priceType === EnumPriceType.Parametro ? true : undefined,
                display: priceDetails?.marketType === EnumMarketType.Horario
              },
              {
                name: 'qHora',
                label: t('pricingDetails:forms.addValue.inputs.hour'),
                type: DataType.SELECT,
                selectOptions: qhOptions,
                required: priceDetails?.marketType === EnumMarketType.CuartoHorario,
                clearable:
                  props.location.state.priceType === EnumPriceType.Parametro ? true : undefined,
                display: priceDetails?.marketType === EnumMarketType.CuartoHorario
              },
              {
                name: 'value',
                label: t('pricingDetails:forms.addValue.inputs.value'),
                type: DataType.NUMBER,
                required: true,
                customDecimalScale: priceDetails?.redondeo
              }
            ]
          }
        ]
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addValueFormDependencies, hoursOptions, qhOptions])

  const editValueFormDefinition =
    React.useMemo<FormDialogDefinitionProps>((): FormDialogDefinitionProps => {
      return {
        id: 'EDIT_VALUE',
        sections: [
          {
            inputs: [
              {
                name: 'startDate',
                label:
                  priceDetails?.marketType === EnumMarketType.Diario ||
                  priceDetails?.marketType === EnumMarketType.Horario ||
                  priceDetails?.marketType === EnumMarketType.Laborables
                    ? t('pricingDetails:forms.addValue.inputs.date')
                    : t('pricingDetails:forms.addValue.inputs.startDate'),
                type: DataType.DATE,
                required: true,
                readOnly:
                  props.location.state.priceType === EnumPriceType.Cotizacion ||
                  props.location.state.priceType === EnumPriceType.Futuro ||
                  props.location.state.priceType === EnumPriceType.IndiceCalculado ||
                  props.location.state.priceType === EnumPriceType.FormulaBase
                    ? true
                    : undefined,
                defaultValue: editValueFormDependencies.formState.startDate,
                onChange: (value, formState: any) => {
                  if (!moment(value).isValid()) {
                    return
                  }
                  if (formState.endDate && moment(formState.endDate).isBefore(moment(value))) {
                    setEditValueFormDependencies({
                      ...editValueFormDependencies,
                      formState: {
                        ...formState,
                        manual: true,
                        startDate: moment(value).toDate(),
                        endDate: moment(formState.startDate).toDate()
                      }
                    })
                  } else {
                    console.log(formState)
                    setEditValueFormDependencies({
                      ...editValueFormDependencies,
                      formState: {
                        ...formState,
                        manual: true,
                        startDate: moment(value).toDate(),
                        endDate: formState.endDate ? moment(formState.endDate).toDate() : undefined
                      }
                    })
                    if (
                      priceDetails?.marketType === EnumMarketType.Diario ||
                      priceDetails?.marketType === EnumMarketType.Horario ||
                      priceDetails?.marketType === EnumMarketType.Laborables
                    ) {
                      setAddValueFormDependencies({
                        ...addValueFormDependencies,
                        formState: {
                          ...formState,
                          endDate: moment(value).toDate()
                        }
                      })
                    }
                  }
                }
              },
              {
                name: 'endDate',
                label: t('pricingDetails:forms.editValue.inputs.endDate'),
                type: DataType.DATE,
                required:
                  priceDetails?.marketType === EnumMarketType.Diario ||
                  priceDetails?.marketType === EnumMarketType.Horario ||
                  priceDetails?.marketType === EnumMarketType.Laborables ||
                  props.location.state.priceType === EnumPriceType.Parametro ||
                  props.location.state.priceType === EnumPriceType.FormulaBase
                    ? undefined
                    : true,
                display:
                  priceDetails?.marketType !== EnumMarketType.Diario &&
                  priceDetails?.marketType !== EnumMarketType.Horario &&
                  priceDetails?.marketType !== EnumMarketType.Laborables,
                readOnly:
                  props.location.state.priceType === EnumPriceType.Cotizacion ||
                  props.location.state.priceType === EnumPriceType.Futuro ||
                  props.location.state.priceType === EnumPriceType.IndiceCalculado ||
                  props.location.state.priceType === EnumPriceType.FormulaBase
                    ? true
                    : undefined,
                clearable:
                  props.location.state.priceType === EnumPriceType.Parametro ? true : undefined,
                defaultValue:
                  props.location.state.priceType === EnumPriceType.Cotizacion
                    ? editValueFormDependencies.formState.startDate
                    : moment(editValueFormDependencies.formState.startDate).isBefore(moment())
                      ? new Date()
                      : null,
                onChange: (value, formState: any) => {
                  if (!moment(value).isValid()) {
                    if (props.location.state.priceType === EnumPriceType.Parametro) {
                      setEditValueFormDependencies({
                        ...editValueFormDependencies,
                        formState: {
                          ...formState,
                          manual: true,
                          endDate: null
                        }
                      })
                      return
                    } else {
                      return
                    }
                  }
                  if (formState.startDate && moment(value).isBefore(moment(formState.startDate))) {
                    setEditValueFormDependencies({
                      ...editValueFormDependencies,
                      formState: {
                        ...formState,
                        manual: true,
                        endDate: moment(formState.startDate).toDate()
                      }
                    })
                  } else {
                    setEditValueFormDependencies({
                      ...editValueFormDependencies,
                      formState: {
                        ...formState,
                        manual: true,
                        endDate: moment(value).toDate(),
                        startDate:
                          formState.startDate !== undefined
                            ? moment(formState.startDate).toDate()
                            : undefined
                      }
                    })
                  }
                }
              },
              {
                name: 'hora',
                label: t('pricingDetails:forms.editValue.inputs.hour'),
                type: DataType.SELECT,
                selectOptions: tableHoursFormat,
                clearable:
                  props.location.state.priceType !== EnumPriceType.Cotizacion ? true : undefined,
                readOnly:
                  props.location.state.priceType !== EnumPriceType.Parametro &&
                  priceDetails?.marketType === EnumMarketType.Horario
                    ? true
                    : undefined,
                display: priceDetails?.marketType === EnumMarketType.Horario,
                onChange: (value, formState: any) =>
                  setAddValueFormDependencies({
                    ...addValueFormDependencies,
                    formState: {
                      ...formState,
                      manual: true
                    }
                  })
              },
              {
                name: 'qHora',
                label: t('pricingDetails:forms.editValue.inputs.hour'),
                type: DataType.SELECT,
                selectOptions: tableQHoursFormat,
                clearable:
                  props.location.state.priceType !== EnumPriceType.Cotizacion ? true : undefined,
                readOnly:
                  props.location.state.priceType !== EnumPriceType.Parametro &&
                  priceDetails?.marketType === EnumMarketType.CuartoHorario
                    ? true
                    : undefined,
                display: priceDetails?.marketType === EnumMarketType.CuartoHorario,
                onChange: (value, formState: any) =>
                  setAddValueFormDependencies({
                    ...addValueFormDependencies,
                    formState: {
                      ...formState,
                      manual: true
                    }
                  })
              },
              {
                name: 'value',
                label: t('pricingDetails:forms.editValue.inputs.value'),
                type: DataType.NUMBER,
                required: true,
                customDecimalScale: priceDetails?.redondeo
              }
            ]
          }
        ]
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editValueFormDependencies])

  // Form Config Ends

  // DataTable Config Starts

  const TableColumns: DataTableColumn[] = [
    {
      name: 'startDate',
      label:
        priceDetails?.marketType === EnumMarketType.Diario ||
        priceDetails?.marketType === EnumMarketType.Horario ||
        priceDetails?.marketType === EnumMarketType.Laborables
          ? t('pricingDetails:dataTable.columns.date')
          : t('pricingDetails:dataTable.columns.startDate'),
      type: DataType.DATE,
      columnWidth: 20
    },
    {
      name: 'endDate',
      label: t('pricingDetails:dataTable.columns.endDate'),
      type: DataType.DATE,
      columnWidth: 30,
      display: !(
        priceDetails?.marketType === EnumMarketType.Diario ||
        priceDetails?.marketType === EnumMarketType.Horario ||
        priceDetails?.marketType === EnumMarketType.Laborables
      )
    },
    {
      name: 'hora',
      label: t('pricingDetails:dataTable.columns.hour'),
      type: DataType.SELECT,
      selectOptions: tableHoursFormat,
      columnWidth: 10,
      display: priceDetails?.marketType === EnumMarketType.Horario
    },
    {
      name: 'qHora',
      label: t('pricingDetails:dataTable.columns.hour'),
      type: DataType.SELECT,
      selectOptions: tableQHoursFormat,
      columnWidth: 10,
      display: priceDetails?.marketType === EnumMarketType.CuartoHorario
    },
    {
      name: 'value',
      label: t('pricingDetails:dataTable.columns.value'),
      type: DataType.NUMBER,
      customDecimalScale: priceDetails?.redondeo ?? 6,
      columnWidth: 10
    },
    {
      name: 'manual',
      label: t('pricingDetails:dataTable.columns.manual'),
      type: DataType.BOOLEAN,
      columnWidth: 10,
      readOnly: true,
      defaultValue: true
    },
    {
      name: 'future',
      label: t('pricingDetails:dataTable.columns.future'),
      type: DataType.BOOLEAN,
      columnWidth: 10,
      display: props.location.state.priceType === EnumPriceType.IndiceCalculado
    }
  ]

  const valuesTableOptions: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: true,
    elevation: 1,
    filterType: FilterType.ADVANCED,
    download: true,
    print: false,
    selectableRows: false,
    canDelete: false,
    canEdit: false,
    customInsertEditModal: true,
    canInsert:
      props.location.state.priceType !== EnumPriceType.IndiceCalculado &&
      props.location.state.priceType !== EnumPriceType.FormulaBase &&
      props.location.state.priceType !== EnumPriceType.Formula,
    onRowInsert: async row => {
      onAddValueClickHandler()
      return true
    },
    fabLabel: t('pricing:dataTable.fab'),
    rowCustomActions: [
      {
        userPermission: UserPermission.EDIT,
        visibleIf: 'canEdit',
        icon: <Edit fontSize="small" />,
        tooltip: t('pricingDetails:dataTable.customActions.edit'),
        onClick: (value, a) => onEditValueClickHandler(value)
      },
      {
        userPermission: UserPermission.EDIT,
        visibleIf: 'canEdit',
        icon: <Delete fontSize="small" />,
        tooltip: t('pricingDetails:dataTable.customActions.delete'),
        onClick: value => onDeleteValueClickHandler(value)
      }
    ],
    mainToolbarCustomActions:
      props.location.state.priceType === EnumPriceType.IndiceCalculado ||
      props.location.state.priceType === EnumPriceType.FormulaBase
        ? [
            {
              icon: <MoveToInbox fontSize="small" />,
              tooltip: t('pricingDetails:dataTable.mainToolbarCustomActions.addMasive'),
              onClick: () => setOpenAddMassiveDialog(true),
              userPermission: UserPermission.EDIT
            },
            {
              icon: <Cached fontSize="small" />,
              tooltip: t('pricingDetails:dataTable.mainToolbarCustomActions.recalculateValues'),
              onClick: () => handleRecalculateValues()
            }
          ]
        : [
            {
              icon: <MoveToInbox fontSize="small" />,
              tooltip: t('pricingDetails:dataTable.mainToolbarCustomActions.addMasive'),
              onClick: () => setOpenAddMassiveDialog(true),
              userPermission: UserPermission.EDIT
            }
          ],
    onFilterChange: (filter: ColumnFilter[]) => {
      storeDataTableFilterForCurrentPage(filter)
    },
    onSearchChange: (search: string) => {
      storeDataTableSearchForCurrentPage(search)
    }
  }

  // DataTable Config Ends

  // Hooks Starts

  useEffect(() => {
    fetchPriceDetailsById(props.location.state.priceId)
    fetchPriceValuesList(props.location.state.priceId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.state.priceId])

  useEffect(() => {
    fetchSubscribedPrices()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.state.priceId])

  useEffect(() => {
    updateFormDefinition(addValueFormDefinition, addValueFormDependencies.formState)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addValueFormDefinition])

  useEffect(() => {
    updateFormDefinition(editValueFormDefinition, editValueFormDependencies.formState)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editValueFormDefinition])

  useEffect(() => {
    fetchFranjasHorarias()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getInitialHourOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceValues])

  useEffect(() => {
    setPriceCoefficientData(priceCoefficientAPIListtoTableMapper(priceCoefficients ?? []))
    setIsSavingPriceCoefficientsDisabled(true)
  }, [priceCoefficients])

  // Hooks Ends

  return (
    <Page notification={globalNotification} layout={PageLayout.MULTI_COLUMN} error={errorProps}>
      <PageLeftColumn>
        {priceDetails ? (
          <>
            <Typography variant="h1" color="primary" noWrap={true}>
              {isFetchingLinkedComponent ? (
                <Skeleton variant="text" width={200} />
              ) : (
                (linkedPriceComponentTypeCode ?? priceDetails.code)
              )}
            </Typography>
            <List className={classes.resume}>
              <ListItem disableGutters>
                <Typography variant={'h2'}>
                  {isFetchingLinkedComponent ? (
                    <Skeleton variant="text" width={160} />
                  ) : (
                    (linkedEntityCode ?? priceDetails?.description)
                  )}
                </Typography>
              </ListItem>
              <ListItem divider disableGutters>
                <Typography variant={'caption'}>
                  {t(`pricingDetails:leftColumn.captions.type`)}
                </Typography>
                <Typography variant={'subtitle2'}>
                  {t(`pricingDetails:leftColumn.values.${priceDetails?.priceType}`)}
                </Typography>
              </ListItem>
              {priceDetails?.marketType && (
                <ListItem divider disableGutters>
                  <Typography variant={'caption'}>
                    {t(`pricingDetails:leftColumn.captions.market`)}
                  </Typography>
                  <Typography variant={'subtitle2'}>
                    {t(
                      `pricingDetails:leftColumn.values.${enumValueToKey(
                        EnumMarketType,
                        priceDetails?.marketType
                      )}`
                    )}
                  </Typography>
                </ListItem>
              )}
              <ListItem divider disableGutters>
                <Typography variant={'caption'}>
                  {t(`pricingDetails:leftColumn.captions.commodity`)}
                </Typography>
                <Typography variant={'subtitle2'}>
                  {t(
                    `pricingDetails:leftColumn.values.${enumValueToKey(
                      EnumCommodity,
                      props.location.state.commodity
                    )}`
                  )}
                </Typography>
              </ListItem>
              <ListItem divider disableGutters>
                <Typography variant={'caption'}>
                  {t(`pricingDetails:leftColumn.captions.priceUnit`)}
                </Typography>
                <Typography variant={'subtitle2'}>
                  {t(
                    `enums:CurrencyAndUnit.${enumKeyToValue(
                      EnumPrecioUnitario,
                      priceDetails?.precioUnitario
                    )}`
                  )}
                </Typography>
              </ListItem>
              <ListItem divider disableGutters>
                <Typography variant={'caption'}>
                  {t(`pricingDetails:leftColumn.captions.rounding`)}
                </Typography>
                <Typography variant={'subtitle2'}>
                  {t(`enums:EnumRedondeo.${enumKeyToValue(EnumRedondeo, priceDetails?.redondeo)}`)}
                </Typography>
              </ListItem>
              {(props.location.state.priceType === EnumPriceType.IndiceCalculado ||
                props.location.state.priceType === EnumPriceType.FormulaBase ||
                props.location.state.priceType === EnumPriceType.Dummy) && (
                <>
                  <ListItem divider disableGutters>
                    <Typography variant={'caption'}>
                      {t(`pricingDetails:leftColumn.captions.expression`)}
                    </Typography>
                    <Typography variant={'subtitle2'}>{priceDetails?.priceExpression}</Typography>
                  </ListItem>
                  <ListItem divider disableGutters>
                    <Typography variant={'caption'}>
                      {t(`pricingDetails:leftColumn.captions.priceCalculationType`)}
                    </Typography>
                    <Typography variant={'subtitle2'}>
                      {priceDetails?.priceCalculationType}
                    </Typography>
                  </ListItem>
                  <ListItem divider disableGutters>
                    <Typography variant={'caption'}>
                      {t(`pricingDetails:leftColumn.captions.version`)}
                    </Typography>
                    <Typography variant={'subtitle2'}>{priceDetails?.version}</Typography>
                  </ListItem>
                </>
              )}
            </List>
          </>
        ) : (
          <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={9}></FormSkeleton>
        )}
      </PageLeftColumn>
      <PageCenterColumn>
        <PageHeader title={t('pricingDetails:title')}>
          <Button onClick={onBackButtonClickHandler} size="small" color="primary">
            {t('pricingDetails:mainActions.back')}
          </Button>
          <ButtonWithPermissions
            onClick={onDeleteClickHandler}
            size="small"
            color="primary"
            hasPermission={
              EnumPriceType.Apuntamiento !== props.location.state.priceType &&
              hasPermission(Resources.Pricing, [UserPermission.EDIT])
            }
            disabled={
              priceDeleteDisabled || props.location.state.priceType === EnumPriceType.Formula
            }
          >
            {t('pricingDetails:mainActions.deletePrice')}
          </ButtonWithPermissions>
          <ButtonWithPermissions
            onClick={onEditComponentClickHandler}
            size="small"
            color="primary"
            hasPermission={
              EnumPriceType.Apuntamiento === props.location.state.priceType &&
              hasPermission(Resources.Pricing, [UserPermission.EDIT])
            }
            disabled={!priceComponentID}
          >
            {t('pricingDetails:mainActions.editPriceComponent')}
          </ButtonWithPermissions>
          <ButtonWithPermissions
            onClick={onDeleteComponentClickHandler}
            size="small"
            color="primary"
            hasPermission={
              EnumPriceType.Apuntamiento === props.location.state.priceType &&
              hasPermission(Resources.Pricing, [UserPermission.EDIT])
            }
            disabled={!priceComponentID}
          >
            {t('pricingDetails:mainActions.deletePriceComponent')}
          </ButtonWithPermissions>
          <ButtonWithPermissions
            variant="contained"
            onClick={() => setShowEditPriceDialog(true)}
            size="small"
            color="primary"
            hasPermission={hasPermission(Resources.Pricing, [UserPermission.EDIT])}
            disabled={
              typeof priceDetails === 'undefined' ||
              props.location.state.priceType === EnumPriceType.Formula
            }
          >
            {t('pricingDetails:mainActions.editPrice')}
          </ButtonWithPermissions>
        </PageHeader>
        {priceTypeIsParametroPeriodo ? (
          <PricePeriodCard
            raised
            show={priceTypeIsParametroPeriodo}
            isFetchingPricePeriods={isFetching || isFetchingPricePeriods} //isFetchingPrice is use to handle pricePeriods rounding on table & Form
            pricePeriodData={pricePeriodData}
            rounding={priceDetails?.redondeo}
            onAddPricePeriod={handleAddPricePeriod}
            onEditPricePeriod={handleEditPricePeriod}
            onDeletePricePeriod={handleDeletePricePeriod}
          />
        ) : priceTypeIsApuntamiento ? (
          <PriceCoefficientsCard
            priceCoefficientsList={priceCoefficientData}
            isLoading={isFetchingPriceCoefficients}
            rounding={priceDetails?.redondeo ?? 6}
            onTableDataChange={handlePriceCoefficientsDataChange}
            showSaveHandler
            saveButtonDisabled={isSavingPriceCoefficientsDisabled}
            onSaveHandler={() => handleSavePriceCoefficients(priceCoefficientData)}
            style={{ margin: '0 0 24px 0' }}
            raised={false}
          />
        ) : (
          <DataTable
            className={classes.dataTable}
            title={t('pricingDetails:dataTable.title')}
            data={priceValues}
            columns={TableColumns}
            options={{
              ...valuesTableOptions,
              analytics: {
                customer: getCustomerDomain(),
                view: t('pricingDetails:dataTable.analytics')
              }
            }}
            userPermissions={getUserPermissions(Pages.PricingEdit)}
          />
        )}
        {timeFrames.length > 0 && <CustomFormDialog {...formProps}></CustomFormDialog>}
      </PageCenterColumn>
      {/* <PageRightColumn></PageRightColumn> */}
      {priceDetails && (
        <EditPriceDialog
          show={priceDetails && showEditPriceDialog ? true : false}
          price={priceDetails}
          priceType={props.location.state.priceType}
          commodity={props.location.state.commodity}
          onShowEditPriceDialog={show => setShowEditPriceDialog(show)}
          onRefreshPage={() =>
            setTimeout(() => {
              fetchPriceDetailsById(props.location.state.priceId)
            }, 3000)
          }
        />
      )}
      {openAddMassiveDialog && (
        <AddMasiveDialog onClose={handleCloseAddMasive} /> // onStartRetriesFetch={startRetriesTimer} />
      )}
      <ErrorDetailList {...errorDetailListDialogProps}></ErrorDetailList>

      <PricePeriodFormDialog
        rounding={priceDetails?.redondeo}
        formMode={pricePeriodFormMode}
        open={pricePeriodFormDialogOpen}
        onClose={handlePricePeriodFormDialogClose}
        inputData={pricePeriodFormInputData}
      />
    </Page>
  )
}
